<div class="modal-header">
	<h4 class="modal-title pull-left">Upload file</h4>
	<button type="button" class="close pull-right" aria-label="Close" (click)="cancel()">
		<span aria-hidden="true">&times;</span>
	</button>
</div>

<div class="modal-body">
	<div class="center">

		<div class="container" appDnd (fileDropped)="handleFileInput($event)">
			<h6>{{fileText}}</h6>
			<!-- <img src="assets/img/dnd/ic-upload-file.svg" alt=""> -->
			<h5>Drag and drop file here</h5>
			<h4>or</h4>
			<input type="file" #fileDropRef id="fileDropRef"
				(change)="handleFileInput($event.target.files)" />
			<label for="fileDropRef">Browse for file</label>
		</div>

		<!-- <div class="input-group mb-3">
			<div class="custom-file">
				<input type="file" class="custom-file-input" [disabled]="isButtonDisabled" (change)="handleFileInput($event.target.files)" id="inputGroupFile01">
				<label class="custom-file-label" for="inputGroupFile01">{{fileText}}</label>
			</div>
		</div> -->

	</div>
</div>

<div class="modal-footer">
	<button type="button" class="btn btn-light" (click)="cancel()">
		Cancel
	</button>
	<am-button (click)="uploadFileToActivity()" [text]="'Upload'" [isLoading]="isButtonDisabled"></am-button>
</div>